/**
 * Wrapper class which combines a market on a specific exchange
 */
export default class MarketWithExchange {
  public exchange: string
  public market: string;
  constructor(market: string, exchange: string) {
    this.market = market;
    this.exchange = exchange
  }
}